module.exports = __webpack_public_path__ + "static/img/lottery.404a82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/lottery.png
// module id = 2+Wj
// module chunks = 1